export function maskCnpj(value) {
    return value
        .replace(/\D/g, '')
        .slice(0, 14)
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})$/, '$1-$2')
        .slice(0, 18);
}
export function maskCnpjHidden(value) {
    const valueToHide = value.includes('*') ? value : value.replace(/\D/g, '');
    return `**.${valueToHide.substring(2, 5)}.${valueToHide.substring(5, 8)}/****-**`;
}
export function unmaskCnpj(value) {
    return value.replace(/\D/g, '');
}
